
import AdsApi from '../libs/ads-request/ads-api';

export default {
  name: 'LoginGrp',
  data: () => ({
    isError: false,
    isInterno: false,
  }),
  computed: {
    mobile() {
      return this.$q.screen.lt.md;
    },
  },
  async mounted() {
    this.loaderShow('Iniciando sesión');

    if (this.$route.query.email && this.$route.query.orderId) {
      this.login();
    } else {
      this.isInterno = true;
    }
  },
  methods: {
    login() {
      const { email } = this.$route.query;
      const { orderId } = this.$route.query;
      const { userInternalId } = this.$route.query;
      const { token } = this.$route.query;
      if (this.$session.exists()) this.$session.destroy();
      if ('superOrderId' in localStorage) localStorage.removeItem('superOrderId');
      if ('isInternal' in localStorage) localStorage.removeItem('isInternal');
      // this.$session.start(60000); //2 min
      this.$session.start(3600000); // Una hora
      // Guardamos en el localStorage si entro un interno a la vista del cliente
      localStorage.setItem('isInternal', '1');
      localStorage.setItem('superOrderId', this.$route.query.orderId);
      this.$session.set('superOrderId', this.$route.query.orderId);
      localStorage.setItem('originAuth', true);
      this.$session.set('token', token);
      localStorage.setItem('token', token);
      AdsApi.login(email, orderId, userInternalId)
        .then((res) => {
          const response = res.data;

          const brand = this.$session.get('brand') && this.$session.get('brand') !== ''
            ? this.$session.get('brand')
            : process.env.VUE_APP_BRAND;

          if (!response.success) throw new Error(`[${response.errorCode}] ${response.errorDescription}`);

          const { data } = response;
          this.getDataAdviser(data.orders);
          this.$session.set('userInternalId', userInternalId);
          this.$session.set('orderId', data.superOrderId);
          this.$session.set('orderIdDMS', data.superOrderIdDMS);
          this.$session.set('showAdditionalBudgets', false);
          this.$session.set('showPreInvoice', false);
          this.$session.set('dealerId', data.dealerId);
          localStorage.setItem('dealerId', data.dealerId);
          this.$session.set('dealerName', data.dealerName);
          this.$session.set('dealerAddress', data.dealerDireccion);
          this.$session.set('dealerCity', data.dealerCiudad);
          this.$session.set('dealerState', data.dealerEstado);
          this.$session.set('plates', data.plates);
          this.$session.set('model', data.model);
          this.$session.set('year', data.years);
          this.$session.set('customerName', data.customerName);
          this.$session.set('customerRFC', data.customerRFC);
          this.$session.set('customerPhone', data.customerPhone);
          this.$session.set('customerPhoneCode', data.customerPhoneCode);
          this.$session.set('customerAddress', data.customerAddress);
          this.$session.set('orderComments', data.orderComments);
          this.$session.set('receptionKilometers', data.receptionKilometers);
          this.$session.set('dealerIdExt', data.dealerIdExt);
          this.$session.set('customerIdDMS', data.customerIdDMS);
          this.$session.set('orders', data.orders);
          this.$session.set('orderStatus', data.superOrderStatus);
          this.$session.set('showTutorial', false);
          this.$session.set('brand', data.brand.toLowerCase());
          this.$session.set('isInternal', true);
          this.$session.set('token', token);
          this.$session.set('email', email);
          this.$session.set('nameContact', data.nameContact);
          this.$session.set('cellphoneContact', data.cellphoneContact);
          this.$session.set('emailContact', data.emailContact);
          localStorage.setItem('parentSuperOrder', data.parentSuperOrderIdDMS);
          localStorage.setItem('parentSuperOrderId', data.parentSuperOrderId);
          localStorage.setItem('ordersLogin', JSON.stringify(data.orders));
          localStorage.setItem('orderIdDMS', data.orders[0].orderIdDMS);
          if (data.parentSuperOrderId !== null) {
            localStorage.setItem('isParentOrder', true);
          } else {
            localStorage.setItem('isParentOrder', false);
          }
          // Seteamos el theme de la marca
          this.$store.commit('SET_LAYOUT', `${brand[0].toUpperCase()}${brand.substring(1)}Layout`);
          // Seteamos que la sesion fue con el usuario interno.
          this.loaderHide();
          this.$router.push({ name: 'home' });
        })
        .catch((error) => {
          this.loaderHide();
          this.isError = true;
          throw error;
        });
    },
    getDataAdviser(orders) {
      const orderReception = orders.filter((item) => item.orderAdviserName !== null
      && item.orderAdviserEmail !== null);
      this.$session.set('adviserName', orderReception.length > 0 ? orderReception[0].orderAdviserName : '');
      this.$session.set('adviserCellphone', orderReception.length > 0 ? orderReception[0].orderAdviserCellphone : '');
      this.$session.set('adviserEmail', orderReception.length > 0 ? orderReception[0].orderAdviserEmail : '');
      this.$session.set('observations', orderReception.length > 0 ? orderReception[0].orderObservations : '');
    },
  },
};
